module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "startExam",
    staticStyle: {
      "height": "90vh",
      "background": "#fff"
    }
  }, [_c('x-header', {
    staticClass: "zdyheaderBlue",
    attrs: {
      "left-options": {
        showBack: false
      }
    }
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.loadingShow),
      expression: "!loadingShow"
    }]
  }, [_vm._v(_vm._s(_vm.examName) + "\n    ")])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.canAnwser == 1),
      expression: "canAnwser == 1"
    }],
    staticStyle: {
      "margin-top": "46px"
    }
  }, [(_vm.attention) ? _c('div', {
    staticClass: "exam-attention"
  }, [_vm._v("\n        " + _vm._s(_vm.attention) + "\n      ")]) : _vm._e(), _vm._v(" "), _vm._l((_vm.currentModule.subjects), function(item, i) {
    return _c('div', {
      staticClass: "exam-div"
    }, [(item.type === 1) ? _c('choices', {
      ref: item.id,
      refInFor: true,
      attrs: {
        "choice": item,
        "cuIndex": i + 1
      }
    }) : _vm._e(), _vm._v(" "), (item.type === 2) ? _c('multiple-choices', {
      ref: item.id,
      refInFor: true,
      attrs: {
        "multichoice": item,
        "cuIndex": i + 1
      }
    }) : _vm._e(), _vm._v(" "), (item.type === 3) ? _c('judgement', {
      ref: item.id,
      refInFor: true,
      attrs: {
        "judge": item,
        "cuIndex": i + 1
      }
    }) : _vm._e(), _vm._v(" "), (item.type === 4) ? _c('shortAnswer', {
      ref: item.id,
      refInFor: true,
      attrs: {
        "shortAnswer": item,
        "cuIndex": i + 1
      }
    }) : _vm._e()], 1)
  }), _vm._v(" "), _c('div', {
    staticClass: "btnGroup",
    staticStyle: {
      "margin": "25px auto"
    },
    attrs: {
      "align": "center"
    }
  }, [(_vm.currentModuleIndex > 0) ? _c('x-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.loadingShow),
      expression: "!loadingShow"
    }],
    staticStyle: {
      "width": "45%"
    },
    attrs: {
      "type": "primary",
      "mini": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.pre($event)
      }
    }
  }, [_vm._v("上一页")]) : _vm._e(), _vm._v(" "), (_vm.currentModuleIndex < _vm.modules.length - 1) ? _c('x-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.loadingShow),
      expression: "!loadingShow"
    }],
    staticStyle: {
      "width": "45%"
    },
    attrs: {
      "type": "primary",
      "mini": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.next($event)
      }
    }
  }, [_vm._v("下一页")]) : _vm._e(), _vm._v(" "), (_vm.modules.length - 1 == _vm.currentModuleIndex) ? _c('x-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.loadingShow),
      expression: "!loadingShow"
    }],
    staticStyle: {
      "width": "45%"
    },
    attrs: {
      "type": "primary",
      "mini": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.subCommit($event)
      }
    }
  }, [_vm._v("提 交")]) : _vm._e()], 1)], 2), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.canAnwser == 2),
      expression: "canAnwser == 2"
    }],
    staticClass: "paper",
    staticStyle: {
      "margin-top": "46px",
      "font-size": "16px"
    }
  }, [_c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('icon', {
    staticStyle: {
      "margin-bottom": "20px",
      "margin-top": "30px"
    },
    attrs: {
      "type": "success",
      "is-msg": ""
    }
  })], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }, [(_vm.remark) ? _c('p', {
    staticClass: "m-font gray-text"
  }, [_vm._v(_vm._s(_vm.remark))]) : _vm._e(), _vm._v(" "), (_vm.eval) ? _c('hr') : _vm._e(), (_vm.eval) ? _c('p', {
    staticClass: "cyan-text l-font"
  }, [_vm._v("指导评语")]) : _vm._e(), _vm._v(" "), (_vm.eval) ? _c('p', {
    staticClass: "m-font gray-text"
  }, [_vm._v(_vm._s(_vm.eval))]) : _vm._e(), _vm._v(" "), (_vm.suggest) ? _c('hr') : _vm._e(), (_vm.suggest) ? _c('p', {
    staticClass: "cyan-text l-font"
  }, [_vm._v("好孕策略")]) : _vm._e(), _vm._v(" "), (_vm.suggest) ? _c('p', {
    staticClass: "m-font gray-text",
    domProps: {
      "innerHTML": _vm._s(_vm.suggest)
    }
  }) : _vm._e()])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "transfer-dom",
      rawName: "v-transfer-dom"
    }]
  }, [_c('loading', {
    attrs: {
      "text": "加载中..."
    },
    model: {
      value: (_vm.loadingShow),
      callback: function($$v) {
        _vm.loadingShow = $$v
      },
      expression: "loadingShow"
    }
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-09cfdda4","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/project/exam/startExamNoPerson.vue
// module id = tMS6
// module chunks = 5